import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `EmpresaCentro`, method: 'GET', body: null, token: token})
}
